import { useTranslation } from "react-i18next";
import clsx from "clsx";

type Props = {
  level: number;
  text: string;
  isActive?: boolean;
};

export default function FactionImprovementsLevel({ level, text, isActive }: Props) {
  const { t } = useTranslation("faction");

  return (
    <div className="flex flex-col">
      <div className="flex items-center mb-2.5">
        <div className={clsx("size-2 rotate-45", isActive ? "bg-accent-solid" : "bg-white/50")} />
        <div className="ml-2 text-14 font-bold leading-none">
          {level} {t("faction.level")}
        </div>
      </div>
      <div className="flex">
        <div
          className={clsx(
            "self-stretch w-0.5 mx-1 rounded",
            isActive ? "bg-accent-solid" : "bg-white/50",
          )}
        />
        <div className="ml-2 pb-5 text-14 font-bold leading-none">{text}</div>
      </div>
    </div>
  );
}
